import ViewVM from './profile-vm';

export default {
  init(element) {
    setTimeout(() => {
      $('.user-profile__header, .user-profile__content', element).fadeIn();
    }, 500);

    if (!element.dataset.koBindingApplied) {
      ko.applyBindingsWithValidation(
        new ViewVM(JSON.parse(document.getElementById('user_profile_json').value)),
        element
      );

      element.dataset.koBindingApplied = true
    }
  }
};
